import { render, staticRenderFns } from "./CatalogGroup.vue?vue&type=template&id=793b3ea0&"
import script from "./CatalogGroup.vue?vue&type=script&lang=js&"
export * from "./CatalogGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports